export interface MachineManualLanguage {
  number: string;
  name: string;
  version: string;
  language: string;
  masterNumber: string;
  masterName: string;
  masterVersion: string;
  masterLanguage: string;
}

export class MachineManual {
  private _name: string;
  private _orderId: string;
  private _machineType: string;
  private _manualType: string;
  private _productline: string;
  private _languages: MachineManualLanguage[];

  public constructor(name: string, orderId: string, machineType: string, manualType: string, productline: string, languages: MachineManualLanguage[]) {
    this._name = name;
    this._orderId = orderId;
    this._machineType = machineType;
    this._manualType = manualType;
    this._productline = productline;
    this._languages = languages;
  }

  public get name(): string {
    return this._name;
  }

  public set name(value: string) {
    this._name = value;
  }

  public get orderId(): string {
    return this._orderId;
  }

  public set orderId(value: string) {
    this._orderId = value;
  }

  public get machineType(): string {
    return this._machineType;
  }

  public set machineType(value: string) {
    this._machineType = value;
  }

  public get manualType(): string {
    return this._manualType;
  }

  public set manualType(value: string) {
    this._manualType = value;
  }

  public get productline(): string {
    return this._productline;
  }

  public set productline(value: string) {
    this._productline = value;
  }

  public get languages(): MachineManualLanguage[] {
    return this._languages;
  }

  public set languages(value: MachineManualLanguage[]) {
    this._languages = value;
  }

  public static fromJSON(machineManual: any): MachineManual {
    return new MachineManual(machineManual.name, machineManual.orderId, machineManual.machineType, machineManual.manualType, machineManual.productline, machineManual.languages);
  }

  public toJSON(): JSON {
    return {
      name: this._name,
      orderId: this._orderId,
      machineType: this._machineType,
      manualType: this._manualType,
      productline: this._productline,
      languages: this._languages
    } as any as JSON;
  }
}
